import React, { useEffect } from 'react';
import { Button } from 'react-bootstrap';
import { useFormikContext } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import CloseCircle from 'mdi-react/CloseCircleIcon';

import { useImageOnLoad, useModal } from 'modules/shared/hooks';
import { cleanTripFields } from 'modules/common/FillTrip';
import { getAccount } from 'modules/auth/containers/Auth/actions';
import { kioskSelector } from 'modules/kiosk/containers/Kiosk/services/selectors';
import { tripCommonTripSelector } from 'modules/common/CommonTrip/selectors';
import LogoutBtn from 'modules/common/LogoutBtn';
import { peripheralsSelector } from 'modules/common/Header/selectors';
import { getPheripRequest } from 'modules/common/Header/actions';
import { useHistory } from 'react-router';
import logo from 'modules/common/Header/assets/logo.png';
import { pathService } from 'modules/kiosk/containers/Kiosk/services/path.service';
import Clock from '../Clock';
import ModalAcept from '../ModalAcept';

import styles from './KioskHeader.module.scss';

const KioskHeader: React.FC = () => {
  const dispatch = useDispatch();

  const formik = useFormikContext();
  const { setFieldValue } = formik;
  const { handleImageOnLoad, css } = useImageOnLoad();

  const { isShow: isShowGoToMain, openModal: openModalGoToMain, closeModal: closeModalGoToMain } = useModal();

  const trip = useSelector(tripCommonTripSelector);
  const { statusId } = useSelector(kioskSelector);
  const peripherals = useSelector(peripheralsSelector);

  const history = useHistory();
  const intentionId = pathService.getIntention(history.location.pathname);

  const handleGoToMain = () => {
    closeModalGoToMain();

    dispatch(cleanTripFields());

    history.push('/kiosk');
  };

  useEffect(() => {
    dispatch(getAccount());

    if (!peripherals) {
      const depTitle = localStorage.getItem('depTitle');
      if (depTitle) {
        const sgid = depTitle?.split('№')[1]?.charAt(0) || '';
        dispatch(getPheripRequest(sgid));
      }
    }
  }, []);

  useEffect(() => {
    setFieldValue('statusId', statusId);
    // @ts-ignore
    if (statusId && !trip?.statusId) {
      // eslint-disable-next-line
      statusId === 10 ? setFieldValue('tripIntention', 2) : setFieldValue('tripIntention', 1);
    }
    // @ts-ignore
  }, [trip.statusId]);

  return (
    <header className={styles.header}>
      <div className="d-flex flex-row justify-content-between align-items-center w-100">
        <img src={logo} alt="Метінвест" onLoad={handleImageOnLoad} style={{ ...css.fullSize }} />
        <div className="d-flex flex-ro w-75 align-items-center justify-content-end">
          <Clock />

          {!intentionId ? (
            <LogoutBtn classNameLogout={styles.logout} classNameItem={styles.item} />
          ) : (
            <Button
              variant="outline-light border-0 p-0 d-flex jusitfy-content-center align-items-center"
              onClick={openModalGoToMain}
              disabled={!intentionId}
            >
              <CloseCircle size={32} />
            </Button>
          )}
        </div>
      </div>

      {trip.id && (
        <div className="d-flex align-items-center justify-content-between w-100 pl-2 my-3">
          <h2 className="ml-4">
            рейс №{trip.id} {trip.tripIntention === 2 ? 'розвантаження' : 'завантаження'}
          </h2>
        </div>
      )}

      <ModalAcept
        show={isShowGoToMain}
        onHide={closeModalGoToMain}
        onClickVerify={handleGoToMain}
        textTitle="Повернутися на головний екран?"
      />
    </header>
  );
};

export default KioskHeader;
